// extracted by mini-css-extract-plugin
module.exports = {"icon":"LastPasses_icon__36kCf","noData":"LastPasses_noData__2di5s","firstRow":"LastPasses_firstRow__1rBmJ"};